// Sense Firebase: la fitxa pública l'importa (§10.4, pes).

/** Origen de la visita (`?src=` del QR, §12), desat en arribar a la fitxa. */
const SRC_KEY = 'bt.src';
export function rememberSource(src: string | null): void {
  if (!src) return;
  try { sessionStorage.setItem(SRC_KEY, src.slice(0, 30)); } catch { /* sense emmagatzematge: no passa res */ }
}
export function rememberedSource(): string | undefined {
  try { return sessionStorage.getItem(SRC_KEY) ?? undefined; } catch { return undefined; }
}
